import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { OPEN_COMPANY_MODAL } from "../../constants/tables";
import { hideModal } from "../../actions/modalActions";
import CompanyModal from "../Modals/Company/CompanyModal";

// this component simply displays or hides modals
class ModalServer extends React.Component {
  hideModal = () => {
    const modalState = this.props.modals;
    const activeModal = modalState.activeModal;
    this.props.hideModal(activeModal);
  };

  render() {
    const modalState = this.props.modals;
    const activeModal = modalState.activeModal;

    switch (activeModal) {
      case OPEN_COMPANY_MODAL:
        return (
          <CompanyModal
            modalData={modalState.modalData}
            onHideClick={this.hideModal}
          />
        );
      default:
        return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    modals: state.modals,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      hideModal,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalServer);



// WEBPACK FOOTER //
// ./src/components/Modals/ModalServer.js